import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import theme from "../../theme";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import useButtonStyles from "../../styles/useButtonStyles";
import { useAppSelector } from "../../redux/hooks";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import {
  SearchToolTip,
  filterConstants,
  DateConstants,
  permissionsConstants,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import formatDate from "../../util/dateFormat";
interface TableColumn {
  key: string;
  header: string;
  searchable?: boolean;
  filterable?: boolean;
}

const allDealsColumns: TableColumn[] = [
  { key: "dealImage", header: " Image" },
  { key: "deal", header: "Title" },
  { key: "validityStart", header: "Validity start" },
  { key: "validityEnd", header: "Validity End" },
  { key: "membership", header: "Membership" },
  { key: "tier", header: "Tier" },
  { key: "dealStatus", header: "Status" },
];
export const DealMetaData = {
  dealImage: {
    isImage: true,
    linkTo: "",
  },
  deal: {
    isImage: false,
    linkTo: "",
  },
  validityStart: {
    isImage: false,
    linkTo: "",
  },
  membershipTier: {
    isImage: false,
    linkTo: "",
  },
  validityEnd: {
    isImage: false,
    linkTo: "",
  },
  dealStatus: {
    isImage: false,
    linkTo: "",
  },
};
const AllDeals = () => {
  const { getUserPermission: allRewardsPermissions } = usePermissionGetter(
    permissionsConstants.rewards,
    permissionsConstants.all_rewards
  );
  const [searchValue, setSearchValue] = useState("");
  const [validityStart, setValidityStart] = useState("");
  const [validityEnd, setValidityEnd] = useState("");
  const [membership, setMembership] = useState(filterConstants.All);
  const [tier, setTier] = useState(filterConstants.All);
  const [status, setStatus] = useState(filterConstants.All);
  const [filterActive, setFilterActive] = useState(false);
  const [isResetApiCall, setIsResetApiCall] = useState(false);
  const searchInputRef = useRef<HTMLInputElement>();
  const buttonStyles = useButtonStyles();
  const { totalCount, getTotalCounts } = useGetTotalRecords();

  const [openFilter, setOpenFilter] = useState(false);
  // let [data,setData]=useState([])

  const handleClose = () => {
    setOpenFilter(false);
  };

  const resetFields = () => {
    setValidityStart("");
    setValidityEnd("");
    setMembership(filterConstants.All);
    setTier(filterConstants.All);
    setStatus(filterConstants.All);
    setFilterActive(false);
    setIsResetApiCall(true);
  };

  useEffect(() => {
    if (isResetApiCall) getSearchDeals();
  }, [isResetApiCall]);

  const handleMembershipChange = (event: SelectChangeEvent) => {
    setMembership(event.target.value as string);
  };
  const handleTierChange = (event: SelectChangeEvent) => {
    setTier(event.target.value as string);
  };
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  const [getDealsData, setGetDealsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );

  // Old Code - not able to format date
  // function formatDate(inputDateString: any) {
  //   var dateParts = inputDateString.split(/[- :]/);
  //   console.log(dateParts ,'dateparts')
  //   var year = parseInt(dateParts[0], 10);
  //   console.log(year, 'year')
  //   var month = parseInt(dateParts[1], 10);
  //   var day = parseInt(dateParts[2], 10);
  //   var date = new Date(year, month - 1, day);
  //   var formattedDate =
  //     ("0" + date.getDate()).slice(-2) +
  //     "/" +
  //     ("0" + (date.getMonth() + 1)).slice(-2) +
  //     "/" +
  //     date.getFullYear();
  //     console.log(formattedDate, 'formattedDate')
  //   return formattedDate;
  // }

  // function formatDate(inputDateString: any) {
  //   const date = new Date(inputDateString);
  //   const pad = (num: any) => String(num).padStart(2, "0");
  //   const formattedDate = `${date.getFullYear()}-${pad(
  //     date.getMonth() + 1
  //   )}-${pad(date.getDate())}`;

   
  //   return formattedDate
  //   // Output: "2025-12-31"
  // }
  const getSearchDeals = async (searchValue?: string) => {
    let newSearchValue = encodeURIComponent(searchValue ? searchValue : "");
    try {
      setLoading(true);
      let url =
        process.env.REACT_APP_API_URL +
        APIConstants.getMerchantDeals +
        `?filter=rewards&merchantName=${selectedMerchatDetails?.external_id}${
          newSearchValue ? `&QuerySearch=${newSearchValue}` : ""
        }${validityStart ? `&ValidityStartDate=${validityStart}` : ""}${
          validityEnd ? `&ValidityEndDate=${validityEnd}` : ""
        }${
          membership && membership !== filterConstants.All
            ? `&UserType=${membership}`
            : ""
        }${tier && tier !== filterConstants.All ? `&Tier=${tier}` : ""}${
          status && status !== filterConstants.All ? `&Status=${status}` : ""
        }`;
      if (getDealsData.length === 0) getTotalCounts(url, "data.Result.rewards");
      const deals = await axios.get(url);
      let data = deals.data.Result.rewards;
      // let data2=data.filter((element:any)=>if(element!==null))
      let mappedData = data
        .filter((deal: any) => deal)
        .map((deal: any) => {
          const isDealOnline = new Date(deal.endTime) > new Date();
          // }
          return {
            dealImage: deal?.imageUrl ? deal.imageUrl : "-",
            deal: deal.name ? deal.name : "-",
            validityStart: deal?.startTime ? formatDate(deal.startTime) : "-",
            validityEnd: deal?.endTime ? formatDate(deal.endTime) : "-",
            membership: deal?.type ? deal?.type : "-",
            tier: deal?.tier ? deal?.tier : "-",
            dealStatus: deal?.status ? deal?.status : "-",
          };
        });
      setGetDealsData(mappedData);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
      setIsResetApiCall(false);
    }
    if (tier || status || membership) {
      setFilterActive(true);
    }
  };

  useEffect(() => {
    getSearchDeals();
  }, []);

  const handleSearch = () => {
    setGetDealsData([]);
    const searchValue = searchInputRef?.current?.value;
    getSearchDeals(searchValue);
  };

  return (
    <Grid>
      <Grid display={"flex"} justifyContent={"end"} px={4} gap={2} py={4}>
        <SearchInput
          HelpTip={SearchToolTip.Sales}
          onCallBack={handleSearch}
          ref={searchInputRef}
        />
        {allRewardsPermissions("read") && (
          <Button
            variant="text"
            startIcon={
              filterActive ? (
                <FilterAltIcon sx={{ color: theme.color?.secondary }} />
              ) : (
                <FilterAltOutlinedIcon />
              )
            }
            sx={{
              color: theme.color?.newFilterGrey,
              textTransform: "capitalize",
            }}
            onClick={() => {
              setOpenFilter(true);
            }}
          >
            Filter
          </Button>
        )}

        <Dialog onClose={handleClose} open={openFilter} sx={{ ml: "60vw" }}>
          <Grid sx={{ width: "483px", py: 4, px: 2 }}>
            <DialogTitle
              display={"flex"}
              justifyContent={"space-between"}
              borderBottom={theme.border?.smallGrey}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.primary,
                  fontSize: theme.font?.fontSize.large,
                  fontWeight: theme.font?.fontWeight.thicker,
                }}
              >
                Filter
              </Typography>
              <IconButton onClick={() => setOpenFilter(false)}>
                <CloseOutlinedIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
              <Grid borderBottom={theme.border?.newGreyBorder} py={4}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Validity Start
                </Typography>
                <Grid display={"flex"} mt={2} gap={2} width={"70%"}>
                  <TextField
                    value={validityStart}
                    onChange={(e) => setValidityStart(e.target.value)}
                    type="date"
                    size="small"
                    fullWidth
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  ></TextField>
                </Grid>
              </Grid>
              <Grid borderBottom={theme.border?.newGreyBorder} py={4}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Validity End
                </Typography>
                <Grid display={"flex"} mt={2} gap={2} width={"70%"}>
                  <TextField
                    value={validityEnd}
                    onChange={(e) => setValidityEnd(e.target.value)}
                    type="date"
                    size="small"
                    fullWidth
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  ></TextField>
                </Grid>
              </Grid>
              <Grid
                my={2}
                display={"flex"}
                flexDirection={"column"}
                gap={2}
                pb={4}
                borderBottom={theme.border?.newGreyBorder}
              >
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Membership
                </Typography>
                <Grid width={"70%"}>
                  <Select
                    value={membership}
                    label=""
                    onChange={handleMembershipChange}
                    fullWidth
                    size="small"
                    defaultValue={filterConstants.All}
                  >
                    <MenuItem value={filterConstants.All}>All</MenuItem>
                    <MenuItem value={"Shopper"}>Shopper</MenuItem>
                    <MenuItem value={"Corporate"}>Corporate</MenuItem>
                  </Select>
                </Grid>
              </Grid>
              <Grid
                my={2}
                display={"flex"}
                flexDirection={"column"}
                gap={2}
                pb={4}
                borderBottom={theme.border?.newGreyBorder}
              >
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Tier
                </Typography>
                <Grid width={"70%"}>
                  <Select
                    value={tier}
                    label=""
                    onChange={handleTierChange}
                    fullWidth
                    size="small"
                    defaultValue={filterConstants.All}
                  >
                    <MenuItem value={filterConstants.All}>All</MenuItem>
                    <MenuItem value={"Silver"}>Silver</MenuItem>
                    <MenuItem value={"Gold"}>Gold</MenuItem>
                    <MenuItem value={"Diamond"}>Diamond</MenuItem>
                  </Select>
                </Grid>
              </Grid>
              <Grid my={2} display={"flex"} flexDirection={"column"} gap={2}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Status
                </Typography>
                <Grid width={"70%"}>
                  <Select
                    value={status}
                    label=""
                    onChange={handleStatusChange}
                    fullWidth
                    size="small"
                    defaultValue={filterConstants.All}
                  >
                    <MenuItem value={filterConstants.All}>All</MenuItem>
                    <MenuItem value={filterConstants.Active}>Active</MenuItem>
                    <MenuItem value={filterConstants.inActive}>
                      Inactive
                    </MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
              <Button
                sx={{ ...buttonStyles.outlinedSecondary }}
                onClick={() => {
                  resetFields();
                }}
              >
                Reset
              </Button>
              <Button
                sx={{ ...buttonStyles.containedSecondary }}
                onClick={() => {
                  setGetDealsData([]);
                  setOpenFilter(false);
                  getSearchDeals(searchValue);
                }}
              >
                Apply
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
      </Grid>
      {allRewardsPermissions("read") && (
        <InfiniteTable
          header={allDealsColumns}
          contentItems={getDealsData}
          metaData={DealMetaData}
          hasMoreRecords={false}
          isInitialLoading={getDealsData.length === 0 && loading}
          totalRecords={totalCount}
        />
      )}
    </Grid>
  );
};

export default AllDeals;
